import React, { FC } from 'react';

export interface AppImageProps {
  src: string;
  isRawSrc?: boolean;
  alt: string;
  className?: string;
  style?: React.CSSProperties;
}

/**
 * render img present in S3: brandclub/media_asset
 */
export const AppImage: FC<AppImageProps> = ({ src, isRawSrc = false, alt, ...rest }) => {
  return <img src={isRawSrc ? src : src} alt={alt} {...rest} />;
};
